export const OFFER = {
  nickname: 'PRODUCTS.OFFER.nickname',
  icon:'offer'
};
